import React, { useState, useEffect } from "react";
import { object, array, string } from "prop-types";
import { Link } from "@quintype/components";
import Polltype from "../../../story-templates/StoryCard/PolltypeElement";
import get from "lodash/get";

import { getPollingStories } from "../../../helper/api";
import { getSlug, getCollectionName } from "../../../utils/utils";

import Headline from "../../../atoms/Headline";
import RightArrowButton from "../../../atoms/icons/right-arrow-button";
import LeftArrowButton from "../../../atoms/icons/left-arrow-button";
import ScrollSnap from "../../../atoms/ScrollSnap";

import "./organism3.m.css";

const Organism3 = ({ collection, sections, domainSlug }) => {
  const [pollElements, setPollElements] = useState(null);
  const [showPoll, setShowPoll] = useState(false);
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const slug = getSlug(collection, sections, domainSlug, navigateTo);
  const storyFields =
    "headline,slug,url,hero-image-s3-key,hero-image-caption,hero-image-metadata,published-at,story-template,metadata,cards";

  useEffect(() => {
    getPollingStories(collection.slug, storyFields).then((stories) => {
      if (stories.length) {
        processPollElements(stories.slice(0, 5));
      }
    });
    setShowPoll(true);
  }, []);

  // Get all the poll elements and create children/storyelements
  const processPollElements = (stories) => {
    const children = [];
    const pollElementsArray = updatePollElements(stories);

    pollElementsArray.length > 0 &&
      pollElementsArray.forEach((element, index) => {
        children.push(<Polltype id={element["polltype-id"]} />);
      });

    setPollElements(children);
  };

  const updatePollElements = (stories) => {
    const storyPollElements = [];
    stories.forEach(({ story }) => {
      if (
        (story["story-template"] === "poll" || story["story-template"] === "polls") &&
        story.cards &&
        story.cards.length
      ) {
        story.cards.forEach((card) => {
          const cardElements = card["story-elements"];
          if (cardElements) {
            const pollElement = cardElements.find((element) => element.type === "polltype");

            if (pollElement) {
              storyPollElements.push(pollElement);
            }
          }
        });
      }
    });
    return storyPollElements;
  };

  if (!(pollElements && pollElements.length)) {
    return null;
  }

  return (
    <div styleName="wrapper">
      <Link href={slug}>
        <Headline
          text={collectionName}
          headlineType={4}
          headerLevel={2}
          headlineDesign="witharrow"
          className="collection-name-arrow"
        />
      </Link>
      {showPoll && (
        <ScrollSnap leftArrow={<LeftArrowButton />} rightArrow={<RightArrowButton />} src="SixStoriesWithPoll">
          {pollElements}
        </ScrollSnap>
      )}
    </div>
  );
};

Organism3.propTypes = {
  collection: object.isRequired,
  sections: array.isRequired,
  domainSlug: string,
};

export default Organism3;
